import { createContext, useContext, useState } from "react";

const useTopUpBalanceProviderContext = () => {
  const [amount, setAmount] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [network, setNetwork] = useState(null);

  return {
    amount,
    setAmount,
    currency,
    setCurrency,
    network,
    setNetwork,
  };
};

const TopUpBalanceContext = createContext(
  {} as ReturnType<typeof useTopUpBalanceProviderContext>
);

export const TopUpBalanceContextProvider = ({ children }) => {
  return (
    <TopUpBalanceContext.Provider value={useTopUpBalanceProviderContext()}>
      {children}
    </TopUpBalanceContext.Provider>
  );
};

export const useTopUpBalanceContext = () => useContext(TopUpBalanceContext);
